import { useQuery } from '@tanstack/react-query'
import { type InferResponse, fetchClient } from '../../typedClient'

export type TankReadingsDiagnostics = InferResponse<
  '/crossroads/tank_readings/diagnose',
  'post'
>

export interface DiagnoseTankReadingArgs {
  siteSourceId: string
  tankId: string
  sourceSystem: string
}

/**
 * Runs the read-only tank-readings diagnostic for one site/tank in the selected
 * tenant's own mapping namespace. Never cached: the point of the check is the
 * state of the chain right now, so every open re-runs it.
 */
export function useDiagnoseTankReading(
  args: DiagnoseTankReadingArgs,
  enabled: boolean,
) {
  return useQuery({
    queryKey: [
      'tank-readings-diagnose',
      args.siteSourceId,
      args.tankId,
      args.sourceSystem,
    ],
    queryFn: async (): Promise<TankReadingsDiagnostics> => {
      const { data, error } = await fetchClient.POST(
        '/crossroads/tank_readings/diagnose',
        {
          params: { query: { source_system: args.sourceSystem } },
          body: { source_id: args.siteSourceId, tank_id: args.tankId },
        },
      )
      if (error) throw error
      return data
    },
    enabled: enabled && !!args.siteSourceId && !!args.tankId,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  })
}
